import { Reducer } from 'redux';

import { IBlocksState } from 'types/blocks.types';
import * as authConstants from 'redux/constants/auth.constants';
import * as constants from 'redux/constants/blocks.constants';

export const defaultState: IBlocksState = {
  categoryPrices: [],
  cementeryId: null,
  count: 0,
  items: [],
  loading: false,
  selectedItem: null,
  table: {
    page: 1,
    limit: 10,
    search: '',
    sortKey: 'name',
    sortType: 'asc',
  },
};

const blocksReducer: Reducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.BLOCKS_ON_DELETE_REQUESTED:
    case constants.BLOCKS_ON_GET_ALL_REQUESTED:
    case constants.BLOCKS_ON_GET_FORM_REQUESTED:
    case constants.BLOCKS_ON_SAVE_REQUESTED:
      return {
        ...state,
        cementeryId: action.cementeryId,
        loading: true,
      };
    case constants.BLOCKS_ON_GET_FORM_SUCCEEDED:
      return {
        ...state,
        categoryPrices: data.categoryPrices,
        loading: false,
      };
    case constants.BLOCKS_ON_GET_ONE_REQUESTED:
      return {
        ...state,
        cementeryId: action.cementeryId,
        loading: !!action.id,
        selectedItem: null,
      };
    case constants.BLOCKS_ON_GET_ALL_SUCCEEDED:
      return {
        ...state,
        count: data.count,
        items: data.items,
        loading: false,
        table: data.table,
      };
    case constants.BLOCKS_ON_GET_ONE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        selectedItem: data.item,
      };
    case constants.BLOCKS_ON_DELETE_SUCCEEDED:
    case constants.BLOCKS_ON_SAVE_SUCCEEDED:
    case constants.BLOCKS_ON_DELETE_FAILED:
    case constants.BLOCKS_ON_GET_ALL_FAILED:
    case constants.BLOCKS_ON_SAVE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case constants.BLOCKS_ON_GET_FORM_FAILED:
      return {
        ...state,
        categoryPrices: [],
        loading: false,
      };
    case constants.BLOCKS_ON_GET_ONE_FAILED:
      return {
        ...state,
        loading: false,
        selectedItem: null,
      };
    case authConstants.AUTH_ON_LOGOUT_SUCCEEDED:
    case authConstants.AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED:
      return defaultState;
    default:
      return state;
  }
};

export default blocksReducer;
